module.exports = __webpack_public_path__ + "img/order-shortcut.cc9d5a47.svg";